import React from 'react'

import { FormFieldStatus, InputField } from '@gousto-internal/citrus-react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

export const HouseNoInput = () => (
  <Field name="houseNo">
    {({ field, meta }: FieldProps) => (
      <InputField
        id={field.name}
        data-testid="houseNo"
        label="House number or name"
        status={meta.touched && meta.error ? FormFieldStatus.Error : undefined}
        validationMessage={meta.touched ? meta.error : undefined}
        maxLength={35}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...field}
      />
    )}
  </Field>
)
